// extracted by mini-css-extract-plugin
export var lbContainerOuter = "y_s2";
export var lbContainerInner = "y_s3";
export var movingForwards = "y_s4";
export var movingForwardsOther = "y_s5";
export var movingBackwards = "y_s6";
export var movingBackwardsOther = "y_s7";
export var lbImage = "y_s8";
export var lbOtherImage = "y_s9";
export var prevButton = "y_tb";
export var nextButton = "y_tc";
export var closing = "y_td";
export var appear = "y_tf";